import React, {Component} from 'react';
import moment from 'moment';
import {Card, Divider, message, Modal, Tag} from 'antd';
import {Link} from 'react-router';
import DescriptionList from '@comm/DescriptionList';
import {queryRelateAddress} from '@api/incubator/oregistapp';
import ComAddressSelect from '../comm/ComAddressSelect';
import TipsOverdue from '../../comm/TipsOverdue';
import TableFile from '../../comm/TableFile';

const { Description } = DescriptionList;

export default class Back extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleAddressChange = uuids => {
    this.uuids = uuids;
  };

  handleSetAddress = () => {
    const { dataInfo } = this.props;
    queryRelateAddress({
      uuid: dataInfo.uuid,
      addressUuids: this.uuids,
    }).then(res => {
      if (res.statusCode === 200) {
        this.props.loadDetail();
        this.handleVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.props;
    const { visible } = this.state;
    const typeFont = ['免费注册', '收费注册'];
    const businessType = ['在签', '待归档', '已归档'];
    const businessStatus = dataInfo.businessStatus || {};
    const termination = dataInfo.termination || {};
    const title = <TipsOverdue interval={businessStatus.interval} />;
    const extra = <Tag color="#108ee9">{businessType[businessStatus.status]}</Tag>;
    const customLink = (
      <Link to={`/incubator/${dataInfo.incubatorUuid}/custom/detail/${dataInfo.customUuid}`}>
        {dataInfo.custom}
      </Link>
    );
    const businessEndDateElement = dataInfo.endDate
      ? moment.unix(dataInfo.endDate / 1000).format('YYYY-MM-DD')
      : '';
    return (
      <Card title={title} className="mb16" extra={extra}>
        <DescriptionList size="large" col={3}>
          <Description term="公司名称">{customLink}</Description>
          <Description term="项目名称">{dataInfo.projectName}</Description>
          <Description term="孵化器">
            <Link to={`/incubator/one/${dataInfo.incubatorUuid}/detail/bill`}>
              {dataInfo.incubator}
            </Link>
          </Description>
          <Description term="收入类型">{typeFont[dataInfo.type]}</Description>
          <Description term="记租时间">
            {dataInfo.beginDate ? moment.unix(dataInfo.beginDate / 1000).format('YYYY-MM-DD') : ''}
          </Description>
          <Description term="到期时间">
            {termination.status === 1 && termination.endDate ? (
              <span>{`${moment
                .unix(termination.beginDate / 1000)
                .format('YYYY-MM-DD')}(原${moment
                .unix(dataInfo.endDate / 1000)
                .format('YYYY-MM-DD')})`}</span>
            ) : (
              businessEndDateElement
            )}
          </Description>

          {dataInfo.price ? <Description term="合同金额">{dataInfo.price}</Description> : null}
          {dataInfo.indeposit ? <Description term="押金">{dataInfo.indeposit}</Description> : null}
          <Description term="地址数量">
            <a onClick={this.handleVisible}>{dataInfo.addressNum || '关联地址'}</a>
          </Description>
        </DescriptionList>
        <DescriptionList size="large" col={2}>
          <Description term="使用地址详情">
            <div>
              {(dataInfo.addresses || []).map(item => {
                return <div key={item.uuid}>{item.name}</div>;
              })}
            </div>
          </Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="附件">
            <TableFile dataSource={dataInfo.files || []} disabled />
          </Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="备注">{dataInfo.reason}</Description>
        </DescriptionList>

        <Modal
          visible={visible}
          width={900}
          title="选择地址"
          onCancel={() => this.handleVisible(false)}
          onOk={this.handleSetAddress}
        >
          <ComAddressSelect
            incubatorUuid={dataInfo ? dataInfo.incubatorUuid : this.props.params.uuid}
            handleChange={this.handleAddressChange}
            addresses={dataInfo ? dataInfo.addresses : []}
          />
        </Modal>
        {termination.status === 1 && termination.endDate ? (
          <div>
            <Divider />
            <DescriptionList size="large" col={1}>
              <Description term="合同终止时间">
                {moment.unix(termination.beginDate / 1000).format('YYYY-MM-DD')}
              </Description>
            </DescriptionList>
            <DescriptionList size="large" col={1}>
              <Description term="附件">
                <TableFile dataSource={termination.files || []} disabled />
              </Description>
            </DescriptionList>
            <DescriptionList size="large" col={1}>
              <Description term="备注">{termination.reason}</Description>
            </DescriptionList>
          </div>
        ) : null}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/incubator/contract/detail/AddressBase.js